import { Form } from './Form/Form';
import { Input, InputError } from './Input';
import { InputDescription } from './InputDescription';
import { Label } from './Label';
import { ReactSelect } from './Select';
import { ShowPasswordInput } from './ShowPasswordInput';
import { SubmitInput } from './SubmitInput';
import { TextArea } from './TextArea';

export const FormComponent = {
  Form,
  Label,
  Input,
  InputDescription,
  InputError,
  ShowPasswordInput,
  SubmitInput,
  TextArea,
  ReactSelect,
};
